









import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class ProjectTitle extends Vue {
  @Prop({ required: true }) name!: string;
  @Prop({ required: true }) avatar!: string;
}
